<template>
<v-dialog v-model="popup.show" max-width="500px" transition="slide-y-reverse-transition" persistent scrollable>
  <v-card>
    <v-card-title class="pa-0">
      <v-toolbar class="pl-2" color="transparent" flat>
        <v-spacer></v-spacer>
        <v-toolbar-title class="headline ml-4">{{popup.type}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          color="error"
          @click.native="popup.show = false"
          icon
          flat
        ><v-icon>close</v-icon></v-btn>
      </v-toolbar>
    </v-card-title>
    <v-card-text class="pa-0">
      <v-layout row wrap>
        <v-flex v-if="popup.type == 'Attempt Details'" xs12 class="text-xs-center px-3 pb-3 pt-1">
          <v-tabs class="pa-0 ma-0" v-model="tab" color="transparent" slider-color="accent" centered>
            <v-tab ripple>Questions</v-tab>
            <v-tab ripple>Grade Breakdown</v-tab>
            <v-tab-item>
              <v-layout class="py-2" row wrap justify-center>
                <v-flex v-for="question, i of taskP.questions" :key="i" class="text-xs-left pl-3" xs12>
                  <div>{{i + 1}}: &nbsp;&nbsp;&nbsp;{{getQuestion(question).id}}</div>
                </v-flex>
              </v-layout>
            </v-tab-item>
            <v-tab-item>
              <v-layout v-if="taskP.totals" class="py-2" row wrap justify-center>
                <template v-for="area, i in Object.keys(taskP.totals)">
                  <v-flex class="text-xs-left" xs10 md9>{{area}}</v-flex>
                  <v-flex class="text-xs-right" xs1>
                    <span
                      v-if="taskP.grades[area] >= 65"
                      class="success--text"
                    ><b>{{taskP.grades[area] + '%'}}</b></span>
                    <span
                      v-else-if="taskP.grades[area] >= 50"
                      class="accent--text text--lighten-2"
                    ><b>{{taskP.grades[area] + '%'}}</b></span>
                    <span
                      v-else
                      class="error--text"
                    ><b>{{taskP.grades[area] + '%'}}</b></span>
                  </v-flex>
                  <v-flex v-if="i != (Object.keys(taskP.totals).length - 1)" xs12 md10><v-divider class="my-1"></v-divider></v-flex>
                  <v-flex xs12></v-flex>
                </template>
              </v-layout>
              <v-layout v-else class="py-2" row wrap justify-center>
                <v-flex class="text-xs-center" xs12>
                  <div>No Breakdown Available</div>
                </v-flex>
              </v-layout>
            </v-tab-item>
          </v-tabs>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</v-dialog>
</template>

<script>
import {contentEvent} from '../../main'
export default {
  props: ['popup', 'taskProgress'],
  data: () => ({
    tab: '0'
  }),
  computed: {
    taskP () {
      return this.taskProgress ? this.taskProgress : {}
    }
  },
  methods: {
    broadcast (event) {
      contentEvent.$emit(event)
      this.popup.show = false
    },
    getQuestion (questionKey) {
      return this.$store.getters.questionByKey(questionKey)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/progress/ProgressPopup.vue